import { FormattedMessage } from "react-intl";

const ExchangeMarketTypeHeader = () => {
  return (
    <span className={"collapsible-header_market-type-exchange"}>
      <span className={"col__back"}>
        {" "}
        <FormattedMessage tagName="span" id={"exchange-side-back"} />
      </span>
      <span className={"col__lay"}>
        <FormattedMessage tagName="span" id={"exchange-side-lay"} />
      </span>
    </span>
  );
};
export default ExchangeMarketTypeHeader;
